export default {
  meta: {
    title: '经营看板'
  }
};
